import { render } from "./LyricPage.vue?vue&type=template&id=5c8f1f98&scoped=true"
import script from "./LyricPage.vue?vue&type=script&lang=js"
export * from "./LyricPage.vue?vue&type=script&lang=js"

import "./LyricPage.vue?vue&type=style&index=0&id=5c8f1f98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c8f1f98"]])

export default __exports__